<template>
  <div>
    <InvoiceStatus :status="data.paymentStatus" />

    <RideList
      :data="data"
      :drawerType="drawerType"
      :filters="filters"
      @change="change"
    />
  </div>
</template>

<script>
import { isObject, isArray } from 'utils/functions'
import InvoiceStatus from 'components/globalDrawer/financial/InvoiceStatus'
import RideList from 'components/globalDrawer/rideList'

export default {
  name: 'TabInfo',
  props: {
    data: {
      type: Object,
      required: true
    },
    drawerType: {
      type: String,
      required: true
    },
    filters: {
      type: Object
    }
  },
  components: {
    InvoiceStatus,
    RideList
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.financial.tabs'
    }
  },
  methods: {
    isValidObject (val) {
      return isObject(val)
    },

    isValidArray (val) {
      return isArray(val)
    },

    change (val) {
      this.$emit('change', val)
    }
  }
}
</script>
